import {z} from 'zod';
import {DTConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {conditionCardSchema} from '../../../../../schemas/conditionCardSchema';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {MacroItemTypeValue} from 'common/src/modules/macros/macros.types';

export function convertConditionAPICardToAICard(
  conditionCard: DTConditionNode,
): z.output<typeof conditionCardSchema> {
  const candidate: z.input<typeof conditionCardSchema> = {
    cardId: conditionCard.id,
    name: conditionCard.name ?? `Creative #${conditionCard.id}`,
    description: conditionCard.description ?? '',
    type: NodeType.CONDITION,
    condKey: conditionCard.condKey,
    condKeyType: conditionCard.condKeyType ?? MacroItemTypeValue.Text,
    condOperator: conditionCard.condOperator,
    categories: conditionCard.categories,
    signalDescription: conditionCard.signalDescription,
    conditionType: conditionCard.conditionType,
    outputs: conditionCard.outputs
      .filter((output) => output.type === OutputType.Regular)
      .map((output) => ({
        type: output.type,
        id: output.id,
        name: output.name ?? '',
        nodeId: output.nodeId ?? 0,
        textValues: output.textValues ?? [],
        numericValues: output.numericValues ?? [],
        booleanValue: output.booleanValue ?? null,
        dateValues: output.dateValues?.map((date) => date.toISO()) ?? [],
        datesRange: output.datesRange
          ? {from: output.datesRange.from.toISO(), to: output.datesRange.to.toISO()}
          : null,
      })),
  } satisfies z.output<typeof conditionCardSchema>;

  return candidate;
}
